import Constant from "./constant";
function getLangKeyValue(resource, key, tplObj = {}) {
    const { textResults } = resource;
    let keyValues = textResults[key] || {};
    let str = keyValues[Constant.language || "en"];
    let tplKeys = Object.keys(tplObj);
    if (tplKeys.length > 0) {
        tplKeys.forEach(key => {
            let keyReg = new RegExp(`%${key}%`, "gi");
            str = str.replace(keyReg, tplObj[key]);
        });
    }
    return str || key;
}
const defaultBook = { textResults: {} };
export const getLangKeyValueFun = (resource = defaultBook) => {
    const textResults = Object.assign({}, resource.textResults);
    const book = Object.assign({}, resource, { textResults });
    return (key, tplObj) => {
        return getLangKeyValue(book, key, tplObj);
    };
};
export default getLangKeyValueFun;
